<template>
    <div class="Agree">
        <!-- s: header -->
        <header>
            <img src="@/assets/images/top-bg-basic.png" width="100%" />
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-noscroll">
            <div>
                <ul class="li-bottom-line">
                    <li>
                        <span>
                            <label class="ckb">
                                <input type="checkbox"
                                       v-model="agreeChkAll"
                                       @change="agreeChkFunc('agreeChkAll')" />
                                <i></i>
                                약관 동의, 개인정보 수집 및 이용 모두 동의
                            </label>
                        </span>
                    </li>
                    <li>
                        <span>
                            <label class="ckb">
                                <input type="checkbox"
                                       v-model="agreeChk1"
                                       @change="agreeChkFunc('agreeChk1')" />
                                <i></i>
                                이용약관 동의(필수)
                            </label>
                        </span>
                        <div v-html="useTermsText" class="useTermsScroll"></div>
                    </li>
                    <li>
                        <span>
                            <label class="ckb">
                                <input type="checkbox"
                                       v-model="agreeChk2"
                                       @change="agreeChkFunc('agreeChk2')" />
                                <i></i>
                                개인정보 수집 및 이용 동의(필수)
                            </label>
                        </span>
                        <div v-html="personalText" class="useTermsScroll"></div>
                    </li>
                    <li>
                        <span>
                            <label class="ckb">
                                <input type="checkbox"
                                       v-model="agreeChk3"
                                       @change="agreeChkFunc('agreeChk3')" />
                                <i></i>
                                커뮤니티 운영정책(필수)
                            </label>
                        </span>
                        <div v-html="communityText" class="useTermsScroll"></div>
                    </li>
                </ul>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField">
                    {{errorMsg}}
                </p>
            </transition>
            <div class="flex justify-between mrg-top-15 mrg-btm-20">
                <router-link class="btn-big btn-white width-45"
                             tag="button"
                             to="/login">
                    취소
                </router-link>
                <button class="btn-big btn-bule width-45"
                        @click="joinFun">
                    동의
                </button>
            </div>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>
export default {
    name: 'Agree',
    data() {
        return {
            personalText:'',        // 개인정보수집및이용동의 내용
            useTermsText:'',        // 이용약관동의(필수) 내용
            communityText:'',       // 커뮤니티 운영정책(필수) 내용
            agreeChkAll:false,      // 약관동의,개인정보 전체선택
            agreeChk1:false,        // 이용약관 선택
            agreeChk2:false,        // 개인정보 선택
            agreeChk3:false,        // 커뮤니티 운영정책 선택
            errorField:'',          // error 항목
            errorMsg:'',            // error 메시지
        }
    },
    // $el 생성전
    created(){
        this.useTermsFunc();
        this.personalInfoCollectFunc();
        this.useCommunityFunc();
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.loginMoveFunc();
        },
        // 약관동의
        agreeChkFunc(obj){
            // 전체선택
            if (obj == 'agreeChkAll'){
                if (this[obj]){
                    if (!this.agreeChk1) this.agreeChk1 = true;
                    if (!this.agreeChk2) this.agreeChk2 = true;
                    if (!this.agreeChk3) this.agreeChk3 = true;
                }else{
                    if (this.agreeChk1) this.agreeChk1 = false;
                    if (this.agreeChk2) this.agreeChk2 = false;
                    if (this.agreeChk3) this.agreeChk3 = false;
                }
                // 이용약관
            }else if (obj == 'agreeChk1'){
                if (this[obj] && this.agreeChk2 && this.agreeChk3){
                    this.agreeChkAll = true;
                }else{
                    this.agreeChkAll = false;
                }
                // 개인정보 약관
            }else if (obj == 'agreeChk2'){
                if (this[obj] && this.agreeChk1 && this.agreeChk3){
                    this.agreeChkAll = true;
                }else{
                    this.agreeChkAll = false;
                }
                // 커뮤니티 운영정책 약관
            }else if (obj == 'agreeChk3'){
                if (this[obj] && this.agreeChk1 && this.agreeChk2){
                    this.agreeChkAll = true;
                }else{
                    this.agreeChkAll = false;
                }
            }
        },
        // 회원가입
        joinFun(){
            // 이용약관, 개인정보 약관 체크
            if (!this.agreeChk1 || !this.agreeChk2 || !this.agreeChk3){
                this.errorMsg="이용약관과 개인정보 수집, 커뮤니티 운영정책 모두 동의해주세요";
                this.errorField='agreeChk1';

                return false;
            }
            this.$router.push('/join');
        }
    }
}
</script>

<style scoped>
    .li-bottom-line li {border-bottom:none; padding: 10px 0}
    .useTermsScroll {overflow-y: auto;height: 150px;border: none;padding: 10px;margin: 10px 0;background: #edf6fe;font-size: 13px;color: #000;font-weight: 300;border-radius: 5px; }
    .error-msg {padding-left: 0;text-align: center;}
</style>
